module.exports = __webpack_public_path__ + "static/img/home_case03.482d6b7.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/index/home_case03.png
// module id = se2C
// module chunks = 3